import React from 'react'
import styled from 'styled-components'

const NoneRow = styled.tr<{ $selected?: boolean }>`
  background-color: ${({ $selected, theme }) =>
    $selected
      ? theme.colors.primaryLight || 'rgba(0, 122, 255, 0.05)'
      : 'transparent'};

  td {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.background.secondary || 'rgba(0, 0, 0, 0.02)'};
  }
`

const NoneSelector = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.small};

  input[type='radio'] {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
`

const NoneNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  padding-top: ${({ theme }) => theme.spacing.small};
`

const NoneLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-style: italic;
`

const EmptyCell = styled.td`
  color: ${({ theme }) => theme.colors.text.tertiary};
  text-align: center;
`

export interface NoneOptionRowProps {
  groupName: 'group1' | 'group2'
  isSelected: boolean
  onGroupChange: (group: 'group1' | 'group2', value: string) => void
  label?: string
}

/**
 * Row component for "None" option in exclusive metric groups
 * Allows users to deselect all metrics in a group
 */
export const NoneOptionRow: React.FC<NoneOptionRowProps> = ({
  groupName,
  isSelected,
  onGroupChange,
  label = 'None (hide this metric)',
}) => {
  return (
    <NoneRow $selected={isSelected}>
      <td>
        <NoneNameContainer>
          <NoneSelector>
            <input
              type="radio"
              name={`metric-${groupName}`}
              value="none"
              checked={isSelected}
              onChange={(e) => onGroupChange(groupName, e.target.value)}
            />
          </NoneSelector>
          <NoneLabel>{label}</NoneLabel>
        </NoneNameContainer>
      </td>
      <EmptyCell>-</EmptyCell>
      <EmptyCell>-</EmptyCell>
      <EmptyCell>-</EmptyCell>
    </NoneRow>
  )
}
